import React from 'react'
import About from "../components/About";
import Cta from "../components/Cta";
import FirstView from "../components/FirstView";
import Point from "../components/Point";
import Price from "../components/Price";
import Solution from "../components/Solution";
import Step from "../components/Step";
import Trouble from "../components/Trouble";
import "../App.css";

const Top = () => {
  return (
    <div>
        <FirstView />
        <Trouble />
        <About />
        <Point />
        <Solution />
        <Price />
        <Step />
        <Cta />
    </div>
  )
}

export default Top